import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";

// users
import user1 from "../../../assets/images/users/icon.jpg";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  // Initialize username state as empty string instead of "Admin"
  const [username, setUsername] = useState("");

  useEffect(() => {
    // Function to fetch and set username from session storage
    const fetchUsername = () => {
      const authUser = sessionStorage.getItem("authUser");
      if (authUser) {
        try {
          const userData = JSON.parse(authUser);
          // Check if username exists in userData
          if (userData.username) {
            setUsername(userData.username);
          } else if (userData.displayName) {
            setUsername(userData.displayName);
          } else {
            setUsername("User"); // Fallback if no username found
          }
        } catch (error) {
          console.error("Error parsing user data:", error);
          setUsername("User"); // Fallback in case of parsing error
        }
      }
    };

    // Initial fetch
    fetchUsername();

    // Set up event listener for storage changes
    window.addEventListener('storage', fetchUsername);

    // Cleanup
    return () => {
      window.removeEventListener('storage', fetchUsername);
    };
  }, [props.success]); // Re-run when success prop changes

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">
            {username || "User"} {/* Fallback to "User" if username is empty */}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/userprofile">
            <i className="ri-user-line align-middle me-2" />
            {props.t("Profile")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="ri-lock-unlock-line align-middle me-2" />
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);